module.exports = __webpack_public_path__ + "media/escudos/logo_muni_majes-552cf137.png";